import { CardActionArea, CardContent, Box, CardActions } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { InnerWrapper, OuterWrapper } from "../../wrapper/wrapper";
import {
  CardBody,
  CardIconImage,
  CardPara,
  CardTitle,
  GetStartedButton,
  Title,
} from "./categories.components";
import CategoriesData from "./topCategories";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./categories.css";

function TopCategories() {
  var settings = {
    dots: true,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };

  return (
    <OuterWrapper sx={{ pt: "150px", pb: "200px", bgcolor: "#F8FBFE" }}>
      <InnerWrapper>
        <Title sx={{ px: { xs: 1.5 }, fontSize: { xs: 28, sm: 32 } }}>
          Top Category Domain
        </Title>
        <Box component={Slider} {...settings} sx={{ px: { xs: "10px" } }}>
          {CategoriesData.map((data) => {
            return (
              <CardBody
                sx={{
                  width: { md: "380px !important" },
                  margin: { xs: "1px", md: "2px 20px" },
                }}
              >
                <CardActionArea>
                  <CardIconImage component="img" image={data.imgUrl} alt="" />
                  <CardContent
                    sx={{ height: { xs: 165, sm: 210, md: "initial" } }}
                  >
                    <CardTitle>{data.title}</CardTitle>
                    <CardPara>{data.paragraph}</CardPara>
                  </CardContent>
                </CardActionArea>
                <CardActions sx={{ py: 1.5 }}>
                  <GetStartedButton component={Link} to={data.url}>
                    Get Started
                  </GetStartedButton>
                </CardActions>
              </CardBody>
            );
          })}
        </Box>
      </InnerWrapper>
    </OuterWrapper>
  );
}

export default TopCategories;
